import React from "react"
import { compose, withProps } from "recompose"
import { withScriptjs, withGoogleMap, GoogleMap, Marker, Polygon } from "react-google-maps"
import { DrawingManager } from "react-google-maps/lib/components/drawing/DrawingManager";
const google = window.google; 
const MapWithADrawingManager = compose(
    withProps({
      googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyC6vfMlg8weB3DKX2-ZF5esMSXbCE1tHYA&v=3.exp&libraries=geometry,drawing,places",
      loadingElement: <div style={{ height: `100%` }} />,
      containerElement: <div style={{ height: `400px` }} />,
      mapElement: <div style={{ height: `100%` }} />,
    }),
    withScriptjs,
    withGoogleMap
  )(props =>
    <GoogleMap
    defaultZoom={13}
    defaultCenter={props.coords[0]}
>
{console.log(props.coords)}
    {/* {props.isMarkerShown && <Marker position={{lat: 41.015137, lng: 28.979530}}/>} */}
    <Polygon
        path={props.coords}
        key={1}
        options={{
            fillColor: "#000",
            fillOpacity: 0.4,
            strokeColor: "#000",
            strokeOpacity: 1,
            strokeWeight: 1
        }}
        onClick={() => {
            console.log("ahmet")
        }}/>
</GoogleMap>
  );

class MyFancyComponent extends React.PureComponent {
  state = {
    isMarkerShown: false,
  }

  componentDidMount() {
    this.delayedShowMarker()
  }

  delayedShowMarker = () => {
    setTimeout(() => {
      this.setState({ isMarkerShown: true })
    }, 3000)
  }

  handleMarkerClick = () => {
    this.setState({ isMarkerShown: false })
    this.delayedShowMarker()
  }
  onPolygonComplete = poly => {
    const polyArray = poly.getPath().getArray();
    let paths = [];
    polyArray.forEach(function(path){
      paths.push({lat:path.lat(), long: path.lng()});
    });
    localStorage.setItem("polygon", JSON.stringify(paths));
    console.log(paths);
 }
  render() {
    return (    
      <MapWithADrawingManager
      onPolygonComplete={this.onPolygonComplete}
        isMarkerShown={this.state.isMarkerShown}
        onMarkerClick={this.handleMarkerClick}
        coords={this.props.coords}
      />
    )
  }
}
export default MyFancyComponent;